import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, unref as _unref, createVNode as _createVNode, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = { class: "block w-full mb-4" }
const _hoisted_2 = { class: "grid grid-cols-2 gap-4 w-full" }
const _hoisted_3 = { class: "inputTitle" }
const _hoisted_4 = { class: "inputField flex-grow" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = { class: "error-msg" }
const _hoisted_7 = { class: "inputTitle" }
const _hoisted_8 = { class: "inputField flex-grow" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_10 = { class: "error-msg" }
const _hoisted_11 = { class: "block w-full col-span-2" }
const _hoisted_12 = { class: "inputTitle" }
const _hoisted_13 = { class: "helpText mt-2 mb-2" }
const _hoisted_14 = { class: "grid grid-cols-1 gap-4 w-full" }
const _hoisted_15 = { class: "flex justify-end" }

import {useI18n} from "vue-i18n";
import {useGlobalStore} from "@/stores/GlobalStore";
import {computed, onMounted, reactive, Ref, ref, toRef} from "vue";
import {helpers, required} from "@vuelidate/validators";
import useVuelidate from "@vuelidate/core";
import {BryntumGrid} from "@bryntum/grid-vue-3";
import GridInputFilter from "@/components/GridInputFilter.vue";
import {Grid, Store, StringHelper} from "@bryntum/grid";
import {checkboxColumnConfig} from "@/AppConfig";
import RecipientList from "@/models/entities/RecipientList";
import {ErrorLocationType} from "@/utilities/enums/Enums";
import RecipientService from "@/utilities/services/entities/RecipientService";
import Recipient from "@/models/entities/Recipient";



export default /*#__PURE__*/_defineComponent({
  __name: 'RecipientlistEditPopup',
  props: {
  data: Object
},
  setup(__props) {

const {t} = useI18n();
const globalStore = useGlobalStore();
const recipientService = new RecipientService();
const props = __props
const popupData = toRef(props, 'data') as Ref<RecipientList>;


const rules = computed(() => {
  return {
    name: { required: helpers.withMessage(t('general.validation.required'), required) },
    description: { required: helpers.withMessage(t('general.validation.required'), required) },
  }
})
const v$ = ref(useVuelidate(rules, popupData.value));


const gridStore = new Store()
const grid = ref<{instance:{value:Grid}}|null>(null)
const useGridConfig = {
  emptyText: t("general.noEntries"),
  headerMenuFeature: false,
  height: "360px",
  columns: [
    {
      id:'name',
      field: 'name',
      text: t('recipient.tabs.recipient.grid.name'),
      flex: 1,
      type: "template",
      template: ({record}:any) => {
        return StringHelper.xss`${record.firstName} ${record.lastName}`;
      }
    },
    {
      id: 'email',
      field : 'email',
      text: t('recipient.tabs.recipient.grid.email'),
      flex: 1,
      sortable: true
    },
  ],
  store: gridStore,
  listeners:{
    selectionChange(event:any) {
      if(isInitalizing.value) return;
      for (const r of event.selected){
        popupData.value.recipientAssociations.recipientIds.push((r.originalData as Recipient).id)
      }
      for (const r of event.deselected ){
        popupData.value.recipientAssociations.recipientIds = popupData.value.recipientAssociations.recipientIds.filter(rid => rid !== (r.originalData as Recipient).id)
      }
      popupData.value.recipientCount = popupData.value.recipientAssociations.recipientIds.length;
    },
  },
  enableTextSelection: true,
  selectionMode : {
    row	  : true,
    checkbox: checkboxColumnConfig,
    showCheckAll : true,
    deselectFilteredOutRecords: true
  }
}
const gridConfig = reactive(useGridConfig)

const isInitalizing = ref<boolean>(true);

const setRecipientData = async ()=> {
  const recipients = await recipientService.getForUser(ErrorLocationType.popup);
  if (!recipients) return;

  gridStore.data = recipients;

  // apply selection according to contains value
  if (popupData.value.id >= 0)
    grid.value!.instance.value.selectRows(popupData.value.recipientAssociations.recipientIds);

  // disable swallowing of selection events
  isInitalizing.value = false;
}


onMounted(async ()=> {
  globalStore.modal.validator = {$validate:v$.value.$validate};

  await setRecipientData();
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('recipient.tabs.list.popups.edit.name')) + " * ", 1),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", {
            class: _normalizeClass({ error: v$.value.name.$errors.length })
          }, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((popupData.value.name) = $event)),
              class: "w-full"
            }, null, 512), [
              [_vModelText, popupData.value.name]
            ]),
            _hoisted_5,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(v$.value.name.$errors, (error) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "input-errors",
                key: error.$uid
              }, [
                _createElementVNode("div", _hoisted_6, _toDisplayString(error.$message), 1)
              ]))
            }), 128))
          ], 2)
        ])
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t('recipient.tabs.list.popups.edit.desc')) + " * ", 1),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", {
            class: _normalizeClass({ error: v$.value.description.$errors.length })
          }, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((popupData.value.description) = $event)),
              class: "w-full"
            }, null, 512), [
              [_vModelText, popupData.value.description]
            ]),
            _hoisted_9,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(v$.value.description.$errors, (error) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "input-errors",
                key: error.$uid
              }, [
                _createElementVNode("div", _hoisted_10, _toDisplayString(error.$message), 1)
              ]))
            }), 128))
          ], 2)
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.$t('recipient.tabs.list.popups.edit.recipients')), 1),
        _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.$t('recipient.tabs.list.popups.edit.helpText')), 1),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _createVNode(GridInputFilter, {
              gridStore: _unref(gridStore),
              hideFilterButton: true
            }, null, 8, ["gridStore"])
          ]),
          _createVNode(_unref(BryntumGrid), _mergeProps({
            ref_key: "grid",
            ref: grid
          }, gridConfig, { readOnly: true }), null, 16)
        ])
      ])
    ])
  ]))
}
}

})